import { AnimatePresence, motion } from 'framer-motion'
import { CaretDown, CaretUp, CheckSquare } from '@phosphor-icons/react'
import * as Accordion from '@radix-ui/react-accordion'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { useIsActivePath } from 'app/packs/src/utils/use-is-active'
import { store } from 'store/index'
import * as SideMenu from 'components/side-menu'

const CHECKIN_SETTINGS_PATH = '/org/check-in-settings'
const PERFORMANCE_CYCLES_PATH = '/org/performance-cycles'

export const CheckinsAccordion = observer(() => {
  const { isActive } = useIsActivePath()

  const orgSlug = store.currentUser?.org?.slug
  const checkinCyclesPath = `/orgs/${orgSlug}/check-in-cycles`
  const performanceCyclesEnabled = store.featureFlags.featureEnabled(
    'checkin_performance_cycles',
  )

  const defaultOpen =
    isActive(CHECKIN_SETTINGS_PATH) ||
    (performanceCyclesEnabled &&
      (isActive(checkinCyclesPath) || isActive(PERFORMANCE_CYCLES_PATH)))
  const [open, setOpen] = React.useState(defaultOpen)

  const onClick = React.useCallback(() => setOpen((prev) => !prev), [])

  const Icon = open ? CaretUp : CaretDown

  return (
    <AnimatePresence initial={!defaultOpen}>
      <Accordion.Root type="single">
        <Accordion.Item value="checkins">
          <Accordion.Header>
            <Accordion.Trigger asChild>
              <SideMenu.ButtonItem onClick={onClick} icon={CheckSquare}>
                <div className="flex items-center justify-between w-full">
                  Check-ins
                  <div className="flex items-center gap-1">
                    <Icon className="h-3.5 text-gray-200 w-3.5" weight="bold" />
                  </div>
                </div>
              </SideMenu.ButtonItem>
            </Accordion.Trigger>
          </Accordion.Header>

          {open && (
            <motion.div
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              initial={{ height: 0, opacity: 0 }}
              transition={{ ease: 'easeInOut', duration: 0.2 }}
            >
              <Accordion.Content
                className="border-0 border-gray-100 border-l border-solid ml-[15px] pl-2"
                forceMount
              >
                <SideMenu.LinkItem
                  href={CHECKIN_SETTINGS_PATH}
                  active={isActive(CHECKIN_SETTINGS_PATH)}
                >
                  Check-in settings
                </SideMenu.LinkItem>
                {performanceCyclesEnabled && (
                  <>
                    <SideMenu.LinkItem
                      href={checkinCyclesPath}
                      active={isActive(checkinCyclesPath)}
                    >
                      Check-in cycles
                    </SideMenu.LinkItem>
                    <SideMenu.LinkItem
                      href={PERFORMANCE_CYCLES_PATH}
                      active={isActive(PERFORMANCE_CYCLES_PATH)}
                    >
                      Performance Cycles
                    </SideMenu.LinkItem>
                  </>
                )}
              </Accordion.Content>
            </motion.div>
          )}
        </Accordion.Item>
      </Accordion.Root>
    </AnimatePresence>
  )
})
